import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import AvailableOn from '../AvailableOn/AvailableOn';
import './TrackOrders.css';

const ESHOPBOX_TRACKING_URL = 'https://kuku-namkeen.eshopbox.com/';

function TrackOrders() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Kuku Namkeen | Track Your Orders</title>
                <link rel="canonical" href="https://kukunamkeen.com/track-orders" />
            </Helmet>

            <section className="track-header-title">
                <div className="max-w-6xl mx-auto px-4">
                    <h1>TRACK YOUR ORDERS</h1>
                </div>
            </section>
            <img
                src="/Image/border-bottom-title.png"
                className="w-full header-title-image"
                alt=""
            />

            <section className="track-page section-space">
                <div className="track-container">
                    <div className="track-link-wrap">
                        <a
                            className="track-submit-btn track-external-btn"
                            href={ESHOPBOX_TRACKING_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Click this to track your order
                        </a>
                    </div>
                </div>
            </section>

            <AvailableOn />
        </>
    );
}

export default TrackOrders;